var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./rentRegistration.constants";
export var useGetAll = (_a = generateHooks(GENERATOR_PARAMS), _a.useGetAll), useDetail = _a.useDetail, usePaged = _a.usePaged, useInfiniteLoad = _a.useInfiniteLoad, useUpdate = _a.useUpdate, useCount = _a.useCount, useRemove = _a.useRemove, useArchive = _a.useArchive, useUnarchive = _a.useUnarchive;
